import React, { useContext, useEffect } from 'react';
import { styleContextApp } from '../../Pages/StyleContext';
import { ModalWrapper, Mask, Content } from './ModalStyle';

export const Modal = ({modalElement, positionType, setModalOpen, backdropClose = false}) => {
    const styleType = useContext(styleContextApp);
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'scroll';
        }
    }, []);
    const position = getPosition(positionType);

    return (
        <ModalWrapper>
            <Mask onClick={() => {
                if(backdropClose) setModalOpen(false);
            }}></Mask>
            <Content style={position} styleType={styleType}>
                {modalElement}
            </Content>
        </ModalWrapper>
    );
};

const getPosition = (positionType) => {
    const toptips = document.getElementById('toptip');
    const toptipsHeight = toptips ? toptips.getBoundingClientRect().height : 0; 
    switch(positionType) {
        case 'leftTop': 
            return {
                position: 'absolute',
                top: `${document.documentElement.scrollTop + toptipsHeight}px`,
                left: 0,
            };
        case 'middle': 
            return {
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            };
        default: 
            return {};
    }
}

